export const NEXT_PUBLIC_RECAPTCHA_SITE_KEY = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!;

export const API_BASE = process.env.NEXT_PUBLIC_API_BASE!;

// Partner sign-up is paused. While false, the navbar "Own & Earn" button
// (formerly "Partner Register"), the floating "Explore Own & Earn" button
// and the footer "VLE Registration" link are hidden, and /partner-register,
// /submit-your-request and /DM-partner-register (with or without a
// referral slug) return 404. Set to true to bring them all back.
export const PARTNER_SIGNUP_ENABLED = false;

// Super Partner sign-up is paused. While false, the navbar "Super Partner"
// button is hidden and /super-partner returns 404. /super-partner-contract
// stays open — approved Super Partners still sign their agreement there.
// Set to true to bring it back.
export const SUPER_PARTNER_SIGNUP_ENABLED = false;

// The "PARTNER" tab (first tab) in the How It Works video section, on the home
// page, /own-and-earn and /how-it-works. Hidden until an Own & Earn explainer
// video replaces the old partner video. Set to true to bring it back.
export const HOW_IT_WORKS_PARTNER_TAB_ENABLED = false;

// The "Detail Partner Program PDF" download on /own-and-earn. Hidden until an
// Own & Earn guide replaces the old partner guide. Set to true to bring it back.
export const PARTNER_GUIDE_DOWNLOAD_ENABLED = false;

// The footer's "VLE Registration" link is a single, site-wide entry point
// (not a per-super-partner referral link an admin generated) — but every
// partner who registers through it still needs to be attributed to a real
// Super Partner. Live and staging have separate databases, so each domain
// maps to a Super Partner that actually exists there. Any other host (e.g.
// localhost) gets the plain, unattributed /DM-partner-register link.
export const FOOTER_SUPER_PARTNER_SLUGS: Record<string, string> = {
  "kissashurutalkies.com": "sheetal-shinde-155",
  "www.kissashurutalkies.com": "sheetal-shinde-155",
  "staging.kissashurutalkies.com": "preeti-wagh-168",
};

console.log("deploy trigger");
